// Configuration for API endpoints
export const config = {
  // API base URL - use environment variable or fallback to relative path for production
  API_BASE_URL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? 'https://ai.linc-interaction.de' : 'http://localhost:8000'),
  
  // WebSocket URL for voice features
  WS_BASE_URL: process.env.REACT_APP_WS_URL || (process.env.NODE_ENV === 'production' ? 'wss://ai.linc-interaction.de' : 'ws://localhost:8000'),
  
  // Environment detection
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Netlify specific configuration
  isNetlify: process.env.REACT_APP_DEPLOYMENT === 'netlify',
};

// Debug logging
console.log('Config loaded:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_WS_URL: process.env.REACT_APP_WS_URL,
  API_BASE_URL: config.API_BASE_URL,
  WS_BASE_URL: config.WS_BASE_URL,
  isProduction: config.isProduction
});

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  const fullUrl = `${config.API_BASE_URL}${endpoint}`;
  console.log(`buildApiUrl: ${endpoint} -> ${fullUrl}`);
  return fullUrl;
};

// Helper function to build WebSocket URLs
export const buildWsUrl = (endpoint: string): string => {
  const wsProtocol = config.isProduction ? 'wss' : 'ws';
  const baseUrl = config.isProduction 
    ? (config.API_BASE_URL.replace('https://', '').replace('http://', '') || window.location.host)
    : 'localhost:8000';
  return `${wsProtocol}://${baseUrl}${endpoint}`;
}; 